import http from "../../http";

export default {
  visitList(params) {
    return http.get("content-service/cnt_article_ops/visited_list", params);
  },
  shareList(params) {
    return http.get("content-service/cnt_article_ops/forward_list", params);
  },
};
